import { useLocation } from 'preact-iso';
import { useLayoutEffect, useState } from 'preact/hooks';
import toast from 'react-hot-toast';
import listenImageUrl from '../../assets/illustrations/listen.svg';
import { Icon } from '../../components/icon';
import { Link } from '../../components/link';
import {
  ContinueWithAppleButton,
  ContinueWithGoogleButton,
} from '../../components/sign-in-buttons';
import TopNav from '../../components/top-nav';
import { useUser, useUserActions } from '../../global-state/user';
import { usePageTitle } from '../../utils/page-title';
import useMediaQuery from '../../utils/use-media-query';
import style from '../sign-in/style.module.scss';

const SignUp = () => {
  usePageTitle('Sign Up');
  const user = useUser();
  const { signUpWithPassword } = useUserActions();
  const showAside = useMediaQuery('(min-width: 900px)');
  const [isSubmitting, setSubmitting] = useState(false);
  const { route } = useLocation();

  useLayoutEffect(() => {
    if (user) {
      toast.success(`Welcome back! You are already signed in.`);
      route('/now');
    }
  }, [user]);

  const onEmailPassSubmit = (event: Event) => {
    event.preventDefault();
    const form = event.target as HTMLFormElement;
    const data = new FormData(form);
    const email = (data.get('email') as string).trim();
    const password = data.get('password') as string;
    const passwordConfirmed = data.get('password_confirmed') as string;

    if (password !== passwordConfirmed) {
      toast.error(`Passwords don't match`);
      return;
    }

    setSubmitting(true);
    signUpWithPassword({ email, password }).then(() => {
      setSubmitting(false);
    });
  };

  return (
    <div class={style.wrapper}>
      <TopNav />
      <div class="top-section">
        <h1 class={style.heading}>Sign Up</h1>

        <div className="flex flex-wrap gap-2">
          <ContinueWithGoogleButton />
          <ContinueWithAppleButton />
        </div>

        <p style="text-align: center; margin: 0.5rem 0 0.75rem"> - or -</p>

        {/* @ts-ignore */}
        <form class={style.form} onSubmit={onEmailPassSubmit}>
          <label>
            <span>Email Address</span>
            <input name="email" type="email" autoComplete="email" required />
          </label>
          <label>
            <span>Password</span>
            <input
              name="password"
              type="password"
              autoComplete="new-password"
              minLength={12}
              required
            />
          </label>
          <label>
            <span>Confirm Password</span>
            <input
              name="password_confirmed"
              type="password"
              autoComplete="new-password"
              minLength={12}
              required
            />
          </label>

          <button class="button button--submit" type="submit" disabled={isSubmitting}>
            Create Account
            {isSubmitting && <Icon sprite="loading-circle" />}
          </button>
        </form>

        <p style={{ marginTop: '1.5rem' }}>
          Already have an account?{' '}
          <Link href="/sign-in" class="text-blue-500 underline">
            Sign In here
          </Link>
        </p>
        <p class="mt-3" style="font-size: 16px">
          <small>
            By signing up and using this app you acknowledge and agree to abide by our{' '}
            <Link href="/terms-of-use" target="_blank" class="text-blue-500 underline">
              Terms&nbsp;of&nbsp;Use
            </Link>{' '}
            and{' '}
            <Link
              href="/privacy-policy"
              target="_blank"
              class="text-blue-500 underline"
            >
              Privacy&nbsp;Policy
            </Link>
            .
          </small>
        </p>
      </div>
      {showAside ? (
        <aside
          class={style.quoteAndImage}
          style={{ backgroundColor: '#ffebcd', color: '#1c2628' }}
        >
          <blockquote>
            <p>
              Few are those who see with their own eyes and feel with their own hearts.
            </p>
            <div>- Albert Einstein</div>
          </blockquote>
          <img src={listenImageUrl} alt="" aria-hidden="true" />
        </aside>
      ) : (
        ''
      )}
    </div>
  );
};

export default SignUp;
